import { useState } from 'react';

const faqs = [
  {
    q: '如何在樱花动漫之家追更最新动漫？',
    a: '在首页热度榜或追更专题中选择你感兴趣的番剧分类，点击即可查看该类型的连载动漫更新列表。我们还提供每日更新提醒，让你第一时间知道喜欢的番剧更新了。',
  },
  {
    q: '新番动漫一般在什么时间更新？',
    a: '日本新番一般按照季度更新，每周固定时间播出。大部分热门新番在周四至周日集中更新，我们会在播出后最快时间内同步上线，方便你追更动漫。',
  },
  {
    q: '樱花动漫之家支持哪些设备观看？',
    a: '我们支持电脑、平板和手机多端访问。无论是桌面端浏览还是移动端追更动漫，都能获得流畅的观看体验。推荐下载移动端APP，随时随地追更新番。',
  },
  {
    q: '需要注册账号才能使用追更功能吗？',
    a: '完全不需要注册。樱花动漫之家所有追更动漫、新番推荐和番剧分类浏览功能都免费开放，无需登录即可畅享全部内容，追更动漫零门槛。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于追更动漫的常见问题，这里都有答案
          </p>
        </div>
        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}